import React from "react";

export const injectProps = (child, props) => {
  if (!child) return null;
  else if (!React.isValidElement(child)) return child;
  else return React.cloneElement(child, { ...props });
};
